/**
 * @jsx jsx
 */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { Colors, H3, Icon } from '@blueprintjs/core';
import { SimpleCard, SimpleCardProps } from './SimpleCard';
import { IconNames } from '@blueprintjs/icons';

export const UnderConstructionCard: React.FC<SimpleCardProps> = ({ ...rest }) => (
	<SimpleCard {...rest}>
		<div className="flex-1" css={container}>
			<Icon
				icon={IconNames.BUILD}
				iconSize={48}
				style={{
					color: Colors.GRAY1,
					alignSelf: 'center',
					marginBottom: '2em',
				}}
			/>
			<H3>Under Construction</H3>
		</div>
	</SimpleCard>
);

const container = css`
	display: flex;
	flex-direction: column;
	align-contet: center;
	justify-content: center;
	text-align: center;
`;
